import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b26f10e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-card-header d-flex justify-center plan-amount pt-7" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"font-weight":"normal","font-size":"30px"},
  class: "pr-2 mt-1"
}, "₹", -1))
const _hoisted_3 = { style: {"font-weight":"normal","font-size":"35px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between px-4 pt-2" }, null, -1))
const _hoisted_5 = {
  class: "pa-2",
  style: {"height":"275px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-flex justify-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "plan-card mt-15" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("b", null, _toDisplayString($props.item?.price), 1)
        ])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: require(`../../assets/internettv/${$props.item?.channels_img}`)
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_btn, { class: "btn-primary" }, {
          default: _withCtx(() => [
            _createTextVNode("Subscribe")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}